import * as c from '@iamo/custody-lib';
import { IConnection } from './Connection';
import { ethers } from 'ethers';

/**
 * Utils-class for the wallet
 */
export class WalletUtils {

    // The blockchain property of the backend connection object.
    connection: IConnection

    /**
     * initializes the class
     * @param connection The backend connection object.
     */
    constructor(connection: IConnection){
        this.connection = connection
    }

    /**
     * Converts an amount of ETH to Wei
     * @param amount The amount in ETH
     * @returns The amount in Wei
     */
    ethToWei(amount: string):string {
        return c.Utils.ethToWei(this.connection, amount)
    }

    /**
     * Converts an amount of Wei to ETH
     * @param amount The amount in Wei
     * @returns The amount in ETH
     */
    weiToEth(amount:string):string {
        return c.Utils.weiToEth(this.connection, amount)
    }

    /**
     * Returns the checksum-address for a provided address
     * @param address The address 
     * @returns The checksum-address
     */
    getChecksumAddress(address: string) {
        return c.Utils.getChecksumAddress(this.connection, address)
    }

    /**
     * Gets the address of the stored privateKey of the connection-object
     * @returns The address of the stored privateKey
     */
    getAddress(): string {
        return c.Utils.getAddress(this.connection)
    }

    /**
     * Gets the ethereum-account from the stored privateKey of the connection-object
     * @returns The address and the privateKey
     */
    getWalletFromLocalKey(): {address: string, privateKey: string} {
        return c.Utils.getWalletFromLocalKey(this.connection)
    }

    /**
     * Creates a wallet from the provided mnemonic
     * @param mnemonic The 12 word string used to generate the wallet.
     * @returns The created wallet
     */
    getWalletFromMnemonic(mnemonic: string): ethers.Wallet {
        return c.Utils.getWalletFromMnemonic(mnemonic)
    }   

    /**
     * Creates a random wallet from the entropy
     * @param entropy The hex string representing the added entropy for the randomness
     * @returns The created wallet
     */
    createRandomWallet(entropy?: string) {
        return c.Utils.createRandomWallet(this.connection, entropy)
    }

    /**
     * Converts a mnemonic to a seed string 
     * @param seedPhrase The 12 word mnemonic
     * @returns The seed-string
     */
    async bip39MnemonicToSeed(seedPhrase: string): Promise<any> {
        return c.Utils.bip39MnemonicToSeed(seedPhrase)
    }

    /**
     * Converts an entropy into a 12 word seed phrase
     * @param entropy The string representing the added entropy to create a Mnemonic
     * @returns The mnemonic
     */
    bip39EntropyToMnemomic(entropy?: string) {
        return c.Utils.bip39EntropyToMnemomic(entropy)
    }

}

export default WalletUtils